(function () {
    'use strict';

    angular
        .module('app')
        .factory('urlapiservice', urlapiservice);

    urlapiservice.$inject = ['$http'];

    function urlapiservice($http) {
        var service = {
            getData: getData
        };

        return service;

        function getData() { }
    }
})();